import { SET_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE } from "../actions";

export default function setErrorMessage(state = "", action) {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return action.payload;
    case CLEAR_ERROR_MESSAGE:
      return "";
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/errorMessage.js